import { ValidatedOrder } from '../../../services/order/useNormalOrderView';
import { PriceInfo } from '../common/PriceInfo';
import classes from './OrderConfirmInstrumentInfo.module.scss';

type OrderConfirmInstrumentInfoProps = {
  orderForm: ValidatedOrder;
};

export const OrderConfirmInstrumentInfo = ({ orderForm }: OrderConfirmInstrumentInfoProps) => {
  const { instrument } = orderForm;

  return (
    <div className={classes.container}>
      <div className={classes.instrumentDetails}>
        <span
          className={classes.instrumentName}
          data-testid="order-confirm-instrument-name"
        >
          {instrument.instrumentName}
        </span>
        <span
          className={classes.instrumentMeta}
          data-testid="order-confirm-instrument-meta"
        >
          {instrument.ticker}
          <span className={classes.separator}>•</span>
          {instrument.isin}
          <span className={classes.separator}>•</span>
          {instrument.marketShortName}
        </span>
      </div>
      <PriceInfo
        instrument={orderForm.instrument}
        source="OrderConfirm"
        dataTestId="order-confirm-price-info"
      />
    </div>
  );
};
